import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../../../constants";
import { useTranslation } from "react-i18next";
import { Form, Input, Typography, Space, Button, Checkbox, Flex } from "antd";
import { baseRouteMaker } from "../../../../../constants/routeConsts";
import { createServiceProvider } from "../../../../../redux/services/auth/authServices";
import "antd/dist/reset.css";
import RequiredLabel from "../../../../common/required-label/RequiredLabel";
import {
  disableOnWheel,
  getPhoneInputFilterOptions,
  sanitizeDataTypeClientSide,
} from "../../../../../utils/utils";
import { colors } from "../../../../../constants/colors";
import TermsConditionModal from "../../../../common/modal/terms-condition/TermsConditionModal";
import { termsConditionData } from "../../../../../constants/data";
import styles from "./SignUp.module.scss";
import CountryPhoneInput from "antd-country-phone-input";
import { allowCharactersOnlyForIntegerNumbers } from "../../../../../utils/appKeyStrokeLimitingUtils";
import TermsAndConditionsDialog from "../../../../common/terms-and-condition-dialog/TermsAndConditionsDialog";
import AgeVerficationModal from "../sign-in/AgeVerficationModal";

const { Title } = Typography;

const SignUp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [agreementDialogOpen, setAgreementDialogOpen] = useState(false);
  const [openTermsAndConditionDialog, setOpenTermsAndConditionDialog] =
    useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dataToBeSentForSignUp, setDataToBeSentForSignUp] = useState(null);

  /* form dependencies */
  const [form] = Form.useForm();
  /* form dependencies */

  const onFinish = async (values) => {
    const { referralCode, ...rest } = values;

    try {
      await form.validateFields(['email', 'phone_number', 'agreement']);

      let dataToBeSent = {
        ...rest,
        phone: {
          phone_number: values?.phone_number?.phone,
          country_code: values?.phone_number?.code,
        },
        registeration_type: "provider",
        referral_code: values?.referralCode || "",
      };
      delete dataToBeSent?.phone_number;
      delete dataToBeSent?.agreement;
  
      setDataToBeSentForSignUp(dataToBeSent);
      setOpenDialog(true);

    } catch (error) {
      console.log(error,'error')
    }
  };

  const sendData = () => {
    dispatch(createServiceProvider(dataToBeSentForSignUp, navigate, setLoading));
  };

  return (
    <>
      <AgeVerficationModal
        open={openDialog}
        sendData={sendData}
        onClose={() => {
          setOpenDialog(false);
        }}
      />
      <Flex vertical gap="1rem" className={styles.signUpContainer}>
        <Title level={1} style={{ color: colors.primaryColor }}>
          {t("SignUp.title")}
        </Title>
        <Title level={4} type="secondary" style={{ margin: 0 }}>
          {t("SignUp.subTitle")}
        </Title>

        <Form
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          requiredMark={false}
          name="signupForm"
          form={form}
        >
          <Flex gap="1rem" vertical>
            <div>
              <Form.Item
                label={
                  <RequiredLabel
                    text={t("SignUp.emailLabel")}
                    required={true}
                  />
                }
                name="email"
                rules={[
                  {
                    type: t("SignUp.typeEmail"),
                    message: t("SignUp.emailValidation"),
                  },
                  {
                    required: true,
                    message: t("SignUp.emailErrorMessage"),
                  },
                ]}
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input placeholder={t("SignUp.emailPlaceholder")} />
              </Form.Item>

              <Form.Item
                initialValue={{
                  code: 971,
                }}
                label={
                  <RequiredLabel
                    text={t("SignUp.phoneNumberLabel")}
                    required={true}
                  />
                }
                name="phone_number"
                rules={[
                  {
                    required: true,
                    validator: async (_, value) => {
                      if (value && !value.phone)
                        return Promise.reject(
                          t("SignUp.phoneNumberErrorMessage")
                        );
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <CountryPhoneInput
                  selectProps={{
                    filterOption: (input, option) =>
                      getPhoneInputFilterOptions(input, option),
                  }}
                  maxLength={15}
                  onKeyDown={(e) => allowCharactersOnlyForIntegerNumbers(e)}
                  inline
                />
              </Form.Item>

              <Form.Item
                label={t("SignUp.referralLabel")}
                style={{ fontWeight: 600 }}
                name="referralCode"
                normalize={(value) => sanitizeDataTypeClientSide(value)}
              >
                <Input placeholder={t("SignUp.referralPlaceholder")} />
              </Form.Item>

              <Flex gap="1rem">
                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(
                              new Error(t("termsCondition.errorMessage"))
                            ),
                    },
                  ]}
                >
                  <Flex gap="1rem">
                    <Checkbox></Checkbox>
                    <Flex horizontal>
                      <Typography.Title
                        level={5}
                        onClick={() => setOpenTermsAndConditionDialog(true)}
                        style={{
                          margin: "0 0 0 5px",
                          color: colors.primaryColor,
                          fontWeight: 400,
                          cursor: "pointer",
                        }}
                      >
                        {t("termsCondition.termsConditionText")}
                      </Typography.Title>
                    </Flex>
                  </Flex>
                </Form.Item>
              </Flex>
            </div>
            <Button
              type="primary"
              style={{ width: "100%" }}
              htmlType="submit"
              loading={loading}
            >
              {t("SignIn.createAcount")}
            </Button>
          </Flex>
        </Form>

        <Space>
          <Title level={5}>{t("SignUp.haveAccount")}</Title>
          <Title
            level={5}
            type="success"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(baseRouteMaker(routes.SIGN_IN))}
          >
            {t("SignUp.login")}
          </Title>
        </Space>
      </Flex>
      <TermsAndConditionsDialog
        open={openTermsAndConditionDialog}
        onClose={() => {
          setOpenTermsAndConditionDialog(false);
        }}
        showAcceptButton={false}
        closable={true}
      />
    </>
  );
};

export default SignUp;
